'use client';

import React from 'react';
import { Outlet } from 'react-router-dom';

type SelfOnboardLayoutProps = {
  orgName?: string;
  orgLogoUrl?: string | null;
};

export default function SelfOnboardLayout({ orgName, orgLogoUrl }: SelfOnboardLayoutProps) {
  return (
    <div className="min-h-screen bg-slate-50 dark:bg-slate-950 flex flex-col">
      <header className="py-6 px-4 flex justify-center">
        {orgLogoUrl ? (
          <img src={orgLogoUrl} alt={orgName ?? 'Organization'} className="h-12 object-contain" />
        ) : (
          <div className="text-center">
            <p className="text-xs uppercase tracking-widest text-slate-400">IQ HRMS</p>
            {orgName ? (
              <p className="text-lg font-semibold text-slate-900 dark:text-white">{orgName}</p>
            ) : null}
          </div>
        )}
      </header>
      <main className="flex-1 flex items-start justify-center px-4 pb-10">
        <div className="w-full max-w-lg">
          <Outlet context={{ orgName, orgLogoUrl }} />
        </div>
      </main>
    </div>
  );
}
